import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { MarketingOrderQRCodes, QRCodeService } from '@lc/core';
import { Observable } from 'rxjs';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'lc-qr-statistics-table',
  templateUrl: './qr-statistics-table.component.html',
  styleUrls: ['./qr-statistics-table.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatFooterCellDef,
    MatFooterCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatFooterRowDef,
    MatFooterRow,
    AsyncPipe,
  ],
})
export class QRStatisticsTableComponent implements OnChanges {
  private qrCodeService = inject(QRCodeService);

  readonly displayedColumns = ['productTitle', 'numberOfScans'];
  data$: Observable<MarketingOrderQRCodes>;

  @Input() marketingOrderId: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.marketingOrderId) {
      this.getQRStats(this.marketingOrderId);
    }
  }

  async getQRStats(marketingOrderId: string) {
    if (marketingOrderId) {
      this.data$ = this.qrCodeService.getQRStats(marketingOrderId);
    }
  }
}
